import { staticHead } from "@/lib/route-head";
import { createFileRoute } from "@tanstack/react-router";
import EventPage from "../pages/EventPage";

export const Route = createFileRoute("/onam-festival")({
  component: () => <EventPage forcedSlug="onam-festival" />,
  head: staticHead("/onam-festival/"),
});
